<div class="h-full flex flex-col justify-between">
  <h2 mat-dialog-title class="!text-xl !font-bold">Error Alert</h2>
  <div class="flex flex-col justify-center items-center min-h-[50px]">
    <span class="!font-bold !text-lg">{{ data.errMessage }}</span>
  </div>
  <div class="flex justify-end p-4">
    <button class="mdlz-btn" (click)="onClose()">Ok</button>
  </div>
</div>
